import { useState } from "react";
import { Box, Container, Stack } from "@bookingcom/bui-react";
import { useNavigate } from "@tanstack/react-router";
import { AddAirlineHeader, AddAirlineForm, AddAirlineSuccessModal } from "../components/AddAirline";

export function AddAirlineComponent() {
  const navigate = useNavigate();
  const [showSuccess, setShowSuccess] = useState(false);
  const [successAirlineCode, setSuccessAirlineCode] = useState("");
  const [successAirlineName, setSuccessAirlineName] = useState("");

  const handleSuccess = (airlineCode: string, airlineName: string) => {
    setSuccessAirlineCode(airlineCode);
    setSuccessAirlineName(airlineName);
    setShowSuccess(true);
  };

  const handleCloseModal = () => {
    setShowSuccess(false);
    setSuccessAirlineCode("");
    setSuccessAirlineName("");
  };

  return (
    <Container>
      <Box
        mixin={{
          paddingBlockStart: 8,
          paddingBlockEnd: 8,
          paddingInlineStart: 0,
          paddingInlineEnd: 0,
        }}
      >
        <Stack gap={8}>
          <AddAirlineHeader onBack={() => navigate({ to: "/overview" })} />
          <AddAirlineForm onSuccess={handleSuccess} />
        </Stack>
      </Box>
      <AddAirlineSuccessModal
        active={showSuccess}
        airlineCode={successAirlineCode}
        airlineName={successAirlineName}
        onClose={handleCloseModal}
      />
    </Container>
  );
}
